import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "datatables.net";
import "datatables.net-bs5";
import "datatables.net-select-dt";
import "datatables.net-responsive-dt";
import "../../Destination/custom.css"; // Your custom styles

const DestinationDetails = () => {
  const tableRef = useRef(null);
  const [showForm, setShowForm] = useState(false);
  const [selectedDestination, setSelectedDestination] = useState(null);
  const [destinationDetails, setDestinationDetails] = useState([
    { destination: "Private", status: "Active", id: 1 },
    { destination: "Government", status: "Inactive", id: 2 },
  ]);

  const [formData, setFormData] = useState({
    destination: "",
    status: "Active",
  });

  useEffect(() => {
    if (tableRef.current) {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
      $(tableRef.current).DataTable({
        responsive: true,
        paging: true,
        searching: true,
        info: true,
      });
    }
  }, [destinationDetails]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedDestination) {
      setDestinationDetails(
        destinationDetails.map((d) =>
          d.id === selectedDestination.id ? { ...formData, id: d.id } : d
        )
      );
    } else {
      setDestinationDetails([
        ...destinationDetails,
        {
          ...formData,
          id: destinationDetails.length
            ? destinationDetails[destinationDetails.length - 1].id + 1
            : 1,
        },
      ]);
    }
    setShowForm(false);
    setFormData({ destination: "", status: "Active" });
    setSelectedDestination(null);
  };

  const handleEdit = (destination) => {
    setSelectedDestination(destination);
    setFormData({
      destination: destination.destination,
      status: destination.status,
    });
    setShowForm(true);
  };

  const handleAddClick = () => {
    setSelectedDestination(null);
    setFormData({ destination: "", status: "Active" });
    setShowForm(true);
  };

  return (
    <div className="destination-detail-list d-flex" style={{ gap: "1rem", padding: "1rem" }}>
      {/* Left side form */}
      {showForm && (
        <div
          className="form-box card"
          style={{
            width: "300px",
            padding: "1rem",
            border: "1px solid #ddd",
            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          }}
        >
          <h2>{selectedDestination ? "Edit Destination Detail" : "Add Destination Detail"}</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label>Destination:</label>
              <input
                type="text"
                name="destination"
                value={formData.destination}
                onChange={handleChange}
                required
                className="form-control"
              />
            </div>
            <div className="mb-3">
              <label>Status:</label>
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
                className="form-control"
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
            <button type="submit" className="btn btn-success me-2">
              Save
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowForm(false)}
            >
              Cancel
            </button>
          </form>
        </div>
      )}

      {/* Right side table */}
      <div className="table-container flex-grow-1">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h1>Destination Details</h1>
            <button className="btn btn-md btn-primary" onClick={handleAddClick}>
              Add Destination Detail
            </button>
          </div>
          <div className="card-body">
            <table
              ref={tableRef}
              className="table table-bordered display"
              style={{ width: "100%" }}
            >
              <thead>
                <tr>
                  <th>Destination</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {destinationDetails.map((destination) => (
                  <tr key={destination.id}>
                    <td>{destination.destination}</td>
                    <td>
                      <span
                        className={`badge ${
                          destination.status === "Active" ? "bg-success" : "bg-danger"
                        }`}
                      >
                        {destination.status}
                      </span>
                    </td>
                    <td>
                      <button
                        className="btn btn-warning btn-sm"
                        onClick={() => handleEdit(destination)}
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DestinationDetails;
